(() => {
  const productHandle = 'short-moldeador-f50';
  const initialButtonText = 'Agregar a mi bolsa';
  const addToCartText = 'Agregar a mi bolsa';

  function getContext() {
    const picker = [...document.querySelectorAll('variant-selects')].find((element) => {
      const productUrl = element.dataset.url || '';
      return productUrl.includes(`/products/${productHandle}`);
    });
    if (!picker) return null;

    const sectionId = picker.dataset.section;
    const form = document.getElementById(`product-form-${sectionId}`);
    const productForm = document.getElementById(`ProductForm-${sectionId}`);
    const variantInput = form?.querySelector('input[name="id"].product-variant-id');
    const addButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const checkoutButton = document.getElementById(`SectionAtcBtn-${sectionId}`);
    const buttonText = addButton?.querySelector('.main-atc__label__text');
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`) || productForm.parentElement;
    const variantsScript = picker.querySelector('script[type="application/json"]');
    if (!form || !productForm || !variantInput || !addButton || !buttonText || !variantsScript) return null;

    let variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (_) {
      return null;
    }

    const groups = [...picker.querySelectorAll('.product-form__input')].filter((group) => {
      return !group.classList.contains('hidden')
        && !group.classList.contains('product-form__input--quantity-breaks')
        && group.querySelector('input[type="radio"], select');
    });
    return { picker, form, productForm, productInfo, variantInput, addButton, checkoutButton, buttonText, variants, groups };
  }

  function selectedValue(group) {
    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = group.querySelector('select');
    return select && select.selectedIndex >= 0 ? select.value : null;
  }

  function ensureMessage(context) {
    let message = context.picker.parentElement?.querySelector('.valmeya-variant-guidance');
    if (!message) {
      message = document.createElement('p');
      message.className = 'valmeya-variant-guidance';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      context.picker.insertAdjacentElement('afterend', message);
    }
    return message;
  }

  function disablePurchase(context, buttonLabel, guidance, isError = false) {
    if (context.variantInput.value !== '') context.variantInput.value = '';
    if (!context.variantInput.disabled) context.variantInput.disabled = true;
    if (!context.addButton.disabled) context.addButton.disabled = true;
    if (context.addButton.getAttribute('aria-disabled') !== 'true') context.addButton.setAttribute('aria-disabled', 'true');
    if (context.checkoutButton && !context.checkoutButton.disabled) context.checkoutButton.disabled = true;
    if (context.checkoutButton && context.checkoutButton.getAttribute('aria-disabled') !== 'true') {
      context.checkoutButton.setAttribute('aria-disabled', 'true');
    }
    if (context.addButton.hasAttribute('data-unavailable')) context.addButton.removeAttribute('data-unavailable');
    if (context.buttonText.textContent.trim() !== buttonLabel) context.buttonText.textContent = buttonLabel;
    const message = ensureMessage(context);
    if (message.textContent !== guidance) message.textContent = guidance;
    message.classList.toggle('is-error', isError);
  }

  function enablePurchase(context, variant) {
    if (context.variantInput.disabled) context.variantInput.disabled = false;
    if (String(context.variantInput.value) !== String(variant.id)) {
      context.variantInput.value = variant.id;
      context.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (context.addButton.disabled) context.addButton.disabled = false;
    if (context.addButton.hasAttribute('aria-disabled')) context.addButton.removeAttribute('aria-disabled');
    if (context.checkoutButton?.disabled) context.checkoutButton.disabled = false;
    if (context.checkoutButton?.hasAttribute('aria-disabled')) context.checkoutButton.removeAttribute('aria-disabled');
    if (context.addButton.hasAttribute('data-unavailable')) context.addButton.removeAttribute('data-unavailable');
    if (context.buttonText.textContent.trim() !== addToCartText) context.buttonText.textContent = addToCartText;
    const message = ensureMessage(context);
    if (message.textContent !== '') message.textContent = '';
    message.classList.remove('is-error');
  }

  function synchronize() {
    const context = getContext();
    if (!context) return;
    const values = context.groups.map(selectedValue);
    const color = values[0] || null;
    const size = values[1] || null;

    if (!color && !size) {
      disablePurchase(context, initialButtonText, 'Selecciona un color y una talla para continuar.');
      return;
    }
    if (!color) {
      disablePurchase(context, 'Elige un color', 'Selecciona un color para continuar.');
      return;
    }
    if (!size) {
      disablePurchase(context, 'Elige una talla', 'Ahora selecciona tu talla.');
      return;
    }

    const variant = context.variants.find((item) => {
      return item.options.length === values.length
        && item.options.every((optionValue, index) => optionValue === values[index]);
    });
    if (!variant || !variant.available) {
      disablePurchase(context, 'Combinación no disponible', 'Prueba otra combinación de color y talla.', true);
      return;
    }
    enablePurchase(context, variant);
  }

  function resetSelection() {
    const context = getContext();
    if (!context || context.picker.dataset.valmeyaGuardReady === 'true') return;
    context.picker.dataset.valmeyaGuardReady = 'true';
    context.groups.forEach((group) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');
      });
      group.querySelectorAll('select').forEach((select) => {
        select.selectedIndex = -1;
      });
    });
    disablePurchase(context, initialButtonText, 'Selecciona un color y una talla para continuar.');
  }

  function initialize() {
    resetSelection();
    if (window.valmeyaCintaVariantGuardBound) return;
    window.valmeyaCintaVariantGuardBound = true;

    document.addEventListener('change', (event) => {
      const picker = event.target.closest('variant-selects');
      if (!picker || !(picker.dataset.url || '').includes(`/products/${productHandle}`)) return;
      const context = getContext();
      if (!context) return;
      const hasMissingChoice = context.groups.map(selectedValue).some((value) => !value);
      if (hasMissingChoice) event.stopPropagation();
      window.requestAnimationFrame(synchronize);
    }, true);

    document.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects')) return;
      window.requestAnimationFrame(synchronize);
    });

    document.addEventListener('submit', (event) => {
      const context = getContext();
      if (!context || event.target !== context.form) return;
      if (context.variantInput.disabled || !context.variantInput.value) {
        event.preventDefault();
        disablePurchase(context, initialButtonText, 'Selecciona un color y una talla antes de continuar.', true);
        context.picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);

    document.addEventListener('shopify:section:load', () => {
      window.requestAnimationFrame(resetSelection);
    });

    const context = getContext();
    if (context?.productInfo) {
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          synchronize();
        });
      });
      observer.observe(context.productInfo, {
        attributes: true,
        attributeFilter: ['disabled', 'data-unavailable', 'aria-disabled'],
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
